module.exports = __webpack_public_path__ + "static/media/29EUNOG15.be19828b.jpg";